var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('h2',[_vm._v("ShopT 2B2T")]),_c('span',[_vm._v("Because we love you.")])])
}]

export { render, staticRenderFns }